import { ChangeDetectionStrategy, Component, Input } from '@angular/core';


@Component({
  selector: 'app-sfl-loading',
  templateUrl: './sfl-loading.component.html',
  styleUrls: ['./sfl-loading.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class SflLoadingComponent {
  @Input() size = 44;
  @Input() overlay = true;
  @Input() label = 'Loading';

  get strokeWidth(): number {
    return Math.max(2, Math.round(this.size / 11));
  }
}
